import Axios from 'axios';

let RESOURCE_ADD = '/CallConnect/AddDealer'
let RESOURCE_DELETE = '/CallConnect/DeleteDealer'

let RESOURCE_CARCODE = '/CallConnect/Carcode'


const oldAPI = process.env.VUE_APP_WS_ENDPOINT;

export default {
    getPublicaciones(payload) {
       return Axios.get(`${RESOURCE_CARCODE}/${payload}`);
    },
    addPublicaciones(payload){
        return Axios.post(RESOURCE_CARCODE, payload);
    },
    deletePublicaciones(payload) {
        return Axios.post(`${oldAPI}/CallConnect/Carcode/delete`, payload);
    },
    addClient(payload) {
        return Axios.post(RESOURCE_ADD, payload);
    },
    deleteClient(payload) {
        return Axios.post(RESOURCE_DELETE, payload);
    }
};